import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Link, Typography } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  footer: {
    position: 'relative',
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: '#79232e',
    color: '#fff',
    padding: theme.spacing(2), 
  },
}));

// Copyright component.
const Copyright = () => {
  const classes = useStyles();
  return (
    
      <Typography variant="body2" color="textSecondary" align="center" className={classes.footer}>
        {'Copyright © '}
        {new Date().getFullYear()}{' '}
        <Link color="inherit" href="https://www.lendersone.com/" target="_blank" rel="noopener noreferrer">
        {'Lenders One.'}
        </Link>{' '}
        {'All Rights Reserved.'}
      </Typography>
  );
};

export default Copyright;